import type {
  ParsedSearch,
  TrendingResponse,
} from '@/features/GlobalSearch/types/index';

export const parseTrendingResults = (
  result: TrendingResponse
): ParsedSearch => {
  if (result.track?.artist !== undefined) {
    return {
      type: 'track',
      image: result.track.artist?.avatar_image
        ? result.track.artist.avatar_image.image_aws_url
        : undefined,
      secondElem: ` - ${result.track.artist.name}`,
      slug: `track/${result.track.artist.slug}/${result.track.slug}`,
      name: result.track.name,
      isTrackItem: true,
      id: result.track.id,
    };
  }

  if (result.artist) {
    const { artist } = result;

    return {
      type: 'artist',
      image: artist.avatar_image ? artist.avatar_image.image_aws_url : '',
      secondElem: ' (Artist)',
      slug: `contributors/${artist.slug ? artist.slug : artist.id}`,
      name: artist.name,
      isTrackItem: false,
      id: artist.id,
    };
  }

  if (result.style) {
    const { style } = result;

    let image = '';

    if (style.tile_image !== '') {
      image = style.tile_image;
    } else if (style.parent?.tile_image) {
      image = style.parent.tile_image;
    }

    return {
      type: 'style',
      image,
      secondElem:
        style.parent === undefined ? undefined : ` - ${style.parent.name}`,
      slug: `browse/style/${style.slug ? style.slug : style.id}`,
      name: style.name,
      isTrackItem: false,
      id: style.id,
    };
  }

  return;
};
